import { CommonModule } from "@angular/common";
import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { AggregatedexternalComponent } from "./aggregated-external-accounts/aggregatedexternal.component";
import { BottombucketComponent } from "./bottombucket/bottombucket.component";
import { DynamicComponent } from "./dycomponent/dynamicComponent";
import { FinAppToolModalComponent } from "./finapp-tool-modal/finapp-tool-modal.component";
import { FooterComponent } from "./footer/footer.component";
import { LinkBannerComponent } from "./link-banner/link-banner.component";
import { MessagesComponent } from "./messages/messages.component";
import { AggErrorHandler } from "../util/aggErrorHandler";
import { RetirementComponent } from "./retirement/retirement.component";

import { RicWcComponent } from "./retirement/ric-wc/ric-wc.component";
import { IncompleteApplicationBannerComponent } from "./incomplete-application-banner/incomplete-application-banner.component";
import { TopbucketComponent } from "./topbucket/topbucket.component";
import { AutoFocusDirective } from "../directives/autoFocus.directive";
import { FeatureToggleDirective } from "../directives/feature-toggle";
import { UtilitiesModule } from "../utilities/utilities.module";
import { PipesModule } from "../utilities/pipes/pipes.module";
import { DynamicLoaderModule } from "../dynamicloadingmodule/dynamicloader.module";
import { FinAppToolModule } from "widgets/src/app/lib/components/finapp-tool/finapp-tool.module";
import { JsInterstitialComponent } from "./js-interstitial/js-interstitial.component";
import { ContibutionMessagesModule } from "../contribution-messages/contribution-messages.module";
import { CookieService } from "ngx-cookie-service";
import { ConfigErrorComponent } from "../util/configErrorComponent";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TwoFactorModule } from './two-factor-authentication/two-factor.module';
import { AccountsComponent } from './accounts/accounts.component';
import { AccountComponent } from './accounts/components/account/account.component';
import { AdditonalAccountsComponent } from './retirement/additonal-accounts/additonal-accounts.component';
import { AccountMessagingComponent } from './retirement/account-messaging/account-messaging.component';
import { MarketingPodComponent } from './marketing-pod/marketing-pod.component';
import { PrucoComponent } from './pruco/pruco.component';
import { PmaComponent } from './pma/pma.component';


@NgModule({
  imports: [
    CommonModule,
    UtilitiesModule,
    PipesModule,
    DynamicLoaderModule,
    FinAppToolModule,
    ContibutionMessagesModule,
    FormsModule,
    ReactiveFormsModule,
    TwoFactorModule
  ],
  providers: [
    CookieService,
    { provide: ErrorHandler, useClass: AggErrorHandler }
  ],
  declarations: [
    AggregatedexternalComponent,
    BottombucketComponent,
    DynamicComponent,
    FinAppToolModalComponent,
    FooterComponent,
    LinkBannerComponent,
    MessagesComponent,
    RetirementComponent,
    RicWcComponent,
    IncompleteApplicationBannerComponent,
    TopbucketComponent,
    AutoFocusDirective,
    FeatureToggleDirective,
    ConfigErrorComponent,
    JsInterstitialComponent,
    AccountComponent,
    AccountsComponent,
    AdditonalAccountsComponent,
    AccountMessagingComponent,
    MarketingPodComponent,
    PrucoComponent,
    PmaComponent
  ],
  exports: [
    AggregatedexternalComponent,
    BottombucketComponent,
    DynamicComponent,
    FinAppToolModalComponent,
    FooterComponent,
    LinkBannerComponent,
    MessagesComponent,
    RetirementComponent,
    RicWcComponent,
    IncompleteApplicationBannerComponent,
    TopbucketComponent,
    AutoFocusDirective,
    FeatureToggleDirective,
    ConfigErrorComponent,
    JsInterstitialComponent,
    AccountComponent,
    AccountsComponent,
    MarketingPodComponent,
    PrucoComponent,
    PmaComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MyaccountsCommonModule {
  constructor() {}
}
